export const GA4_ID_PROD: string = 'G-C11B7Q9XQ2';
export const GA4_ID_TEST: string = 'G-3Y4XMWSTPR';
